import { Component, Vue, State, namespace } from 'nuxt-property-decorator'
import { Tour } from '~/types/tour'

const experience = namespace('experience')

@Component
export default class Index extends Vue {
  @State((state) => state.klook.platform) platform!: Data.Platform
  @experience.State tourHomePageBasic!: Tour.VerticalHomePageBasic

  get isDesktop() {
    return this.platform === 'desktop'
  }

  get searchProps() {
    const {
      search_icon_url,
      search_placeholder,
      search_deeplink
    } = this.tourHomePageBasic || {}

    return {
      icon: search_icon_url,
      placeholder: search_placeholder,
      deepLink: search_deeplink
    }
  }

  get quick_search_click() {
    return this.tourHomePageBasic?.quick_search_click || []
  }

  get backgroundUrl() {
    if (this.isDesktop) {
      return 'https://res.klook.com/image/upload/fl_lossy.progressive,q_85/c_fill,w_1920/v1688097706/UED_new/TnA/TnA_Vertical%20homepage_2305/image_T_A_vertical_homepage_desktop_2x.jpg'
    }

    const url = this.tourHomePageBasic.banner_url

    if (url.includes('c_fill')) {
      return url
    }

    return url.replace('image/upload/', 'image/upload/fl_lossy.progressive,q_85/c_fill,w_800/')
  }
}
